import React from 'react';
import PropTypes from 'prop-types';
import Table from '@decisiv/ui-components/lib/components/Table';
import Tag from '@decisiv/ui-components/lib/components/Tag';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import { t } from '@lingui/macro';

// Lists "this location, across the integrations of its group" for both the
// cascade summary and the removal confirmation, in the same Table + Tag pairing
// the locations list uses. Rows arrive pre-shaped: the cascade speaks in sync
// statuses and the removal in enabled/disabled, and neither belongs in here.
export default function SyncStatusTable({ rows, attentionTitle = null }) {
  const columns = [
    {
      DataCell: (data) => <span>{data.rowData.name}</span>,
      title: t`Integration`,
      name: 'integration',
    },
    {
      DataCell: (data) => (
        <Tag text={data.rowData.statusText} color={data.rowData.statusColor} />
      ),
      title: t`Status`,
      name: 'status',
    },
  ];

  if (attentionTitle) {
    columns.push({
      DataCell: (data) =>
        data.rowData.attention ? (
          <span>{data.rowData.attention}</span>
        ) : (
          <P shade={1} marginBottom={0}>
            &mdash;
          </P>
        ),
      title: attentionTitle,
      name: 'attention',
    });
  }

  return (
    <Table
      columns={columns}
      data={rows}
      kind="secondary"
      getRowKey={({ id }) => id}
    />
  );
}
SyncStatusTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      statusText: PropTypes.string,
      statusColor: PropTypes.string,
      attention: PropTypes.string,
    }),
  ).isRequired,
  attentionTitle: PropTypes.string,
};
